export default {
    createCampaign: 'Create campaign',
    fetchingError: 'Error while fetching the campaigns',
    searchPlaceholder: 'Search campaign',
    viewButton: 'View',
    item: {
        createAt: 'Created on:',
    },
};
